import { Link } from "react-router-dom";

type NavKey = "webinars" | "questions" | "leads" | "settings";

// 管理画面共通のトップバー（ロゴ＋ピルナビ）。
// webinarId があるページでは質問管理・リード一覧も出す。連携設定は常時表示。
export function AdminNav({
  webinarId,
  current,
}: {
  webinarId?: string;
  current: NavKey;
}) {
  const cls = (key: NavKey) =>
    key === current ? "admin-nav-link admin-nav-active" : "admin-nav-link";
  return (
    <nav className="admin-nav">
      <Link className="admin-nav-brand" to="/admin/webinars">
        Webinar Ops
      </Link>
      <div className="admin-nav-group">
        <Link className={cls("webinars")} to="/admin/webinars">
          ウェビナー一覧
        </Link>
        {webinarId && (
          <>
            <Link
              className={cls("questions")}
              to={`/admin/webinars/${webinarId}/questions`}
            >
              質問管理
            </Link>
            <Link
              className={cls("leads")}
              to={`/admin/webinars/${webinarId}/leads`}
            >
              リード一覧
            </Link>
          </>
        )}
        <Link className={cls("settings")} to="/admin/settings">
          連携設定
        </Link>
      </div>
    </nav>
  );
}
